<button class="go-to-route-button {{styleClass}}"
        type="button"
        [class.si-button_only-icon]="icon && !text"
        (click)="onClickButton()">
  <div class="go-to-route-button_container"
       pTooltip="{{tooltip | translate}}"
       tooltipPosition="{{tooltipPosition}}"
       [attr.aria-label]="tooltip">
    <ng-container *ngIf="icon && !iconRight">
      <i class="{{icon}}" [class.mr-2]="text"></i>
    </ng-container>
    <span>{{text | translate}}</span>
    <ng-container *ngIf="icon && iconRight">
      <i class="{{icon}}" [class.ml-2]="text"></i>
    </ng-container>
  </div>
</button>
